export const schools = [
	{
		sigle: "IAM",
		name: "Institut Africain  de Management",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
		pdf: "pdf",
	},
	{
		sigle: "ISI",
		name: "Institut Supérieur d'Informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
		pdf: "pdf",
	},
	{
		sigle: "UCAD",
		name: "Université Cheick Anta Diop",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
		pdf: "pdf",
	},
	{
		sigle: "ISM",
		name: "Institut Supérieur de Management",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
		pdf: "pdf",
	},
	{
		sigle: "UNIPRO",
		name: "Univers Professionnels",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
		pdf: "pdf",
	},
];

export const events = [
	{ title: "Journée Culturelle", name: "ISI 2022" },
	{ title: "Journée Culturelle", name: "IAM 2022" },
	{ title: "Journée Culturelle", name: "ISM 2022" },
	{ title: "Journée d'intégration", name: "UCAD 2022" },
];

export const formations = [
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
	{
		name: "Formation en informatique",
		except: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim totam dolorum tempora, ducimus dolor quam.",
	},
];

